import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { ArborescenceBâtimentaire } from "../actif_arborescence/ArborescenceBâtimentaire";
import { sitesSerivces, actifsService,parcellesService } from "../../services";
import { showToast, CustomDialog } from "..";
import { Actif, Site } from "../../interfaces";
import { useAuth } from "../../utils/UserProvider";
import { Link } from "react-router-dom";
import { createFormDataFromObject } from "../../hooks/useFormData";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import ModalAddSite from "../site/ModalAddSite";

interface ModalCorrespondanceActifProps {
  closeModalCorrespondance: () => void;
  openModalActif: () => void;
  modalIsOpenCorrespondance: boolean;
  setSelectedOptionsSociete: (newvalue: any) => void;
  setSelectedOptionsIndividu: (newvalue: any) => void;
  setSelectedInterlocuteur: (newvalue: any) => void;
  addedActif: Actif;
  setAddedActif: any;
  setLoading: (newvalue: boolean) => void;
}
const ModalCorrespondanceActif = ({
  closeModalCorrespondance,
  openModalActif,
  modalIsOpenCorrespondance,
  addedActif,
  setAddedActif,
  setLoading,
  setSelectedOptionsSociete,
  setSelectedOptionsIndividu,
  setSelectedInterlocuteur,
}: ModalCorrespondanceActifProps) => {

  const queryClient = useQueryClient();
  const [modalAddSiteOpen, setModalAddSiteOpen] = useState(false);
  const [selectedSite, setSelectedSite] = useState<Site | null>(null);
  const [selectedBâtiments, setSelectedBâtiments] = useState([]);
  const [selectedNiveaux, setSelectedNiveaux] = useState([]);
  const [selectedEspaces, setSelectedEspaces] = useState([]);
  const [selectedPieces, setSelectedPieces] = useState([]);
  const { user, client } = useAuth();
  const { data: parcelles } = useQuery({
  queryKey: ["parcelles", client],
  queryFn: async () => {
    if (isGexpertise()) {
      return await parcellesService.getAll();
    } else {
      return await parcellesService.getAll(client.id);
    }
  },
});
  let navigate = useNavigate();
  const isGexpertise = () =>
    user &&
    (user.role.includes("ADMIN_GEXPERTISE") ||
      user.role.includes("ASSISTANT_PROJET"));

  const isAdminOrMaitreAdmin = () =>
    user &&
    (user.role.includes("MAITRE_ADMIN_CLIENT") ||
      user.role.includes("ADMIN_CLIENT"));

  const { data: sites } = useQuery<Site[]>({
    queryKey: ["sites", client],
    queryFn: async () => {
      if (isGexpertise()) {
        return await sitesSerivces.getAll();
      } else {
        return await sitesSerivces.getAll(client.id);
      }
    },
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
      const formData = createFormDataFromObject(addedActif);
      let data_correspondance = {};
      setLoading(true);
      await actifsService.post(formData).then((response) => {
        showToast("success", "Actif ajouté avec succès");
        data_correspondance = {
          actif_id: response.data.id,
          site_id: selectedSite?.id,
          batiment_ids: selectedBâtiments,
          niveau_ids: selectedNiveaux,
          espace_ids: selectedEspaces,
          piece_ids: selectedPieces,
        };
      });

      await actifsService.correspondanceActif(data_correspondance).then(() => {
        showToast(
          "success",
          "Correspondance bâtimentaire effectué avec succes"
        );
        queryClient.refetchQueries({
          queryKey: ["actifs"],
        });
        setLoading(false);
        setSelectedBâtiments([]);
        setSelectedNiveaux([]);
        setSelectedEspaces([]);
        setSelectedPieces([]);
        setSelectedSite(null);
        setAddedActif(null);
        setSelectedOptionsSociete([]);
        setSelectedOptionsIndividu([]);
        setSelectedInterlocuteur(null);

        reset();
        closeModalCorrespondance();
        window.location.reload();
      });
      
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  const selectSite = async (site_id) => {
    try {
      setLoading(true);
      const response = await sitesSerivces.getById(site_id);
      setLoading(false);
      setSelectedSite(response);
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  return (
    <>
      <CustomDialog
        header="Correspondance bâtimentaire"
        visible={modalIsOpenCorrespondance}
        closeModalDialog={() => {}}
      >
        <div className="w-full h-full">
          <div
            className="flex items-center p-4 mt-2 text-md text-blue-800 rounded-lg bg-blue-50 "
            role="alert"
          >
            <svg
              className="flex-shrink-0 inline w-4 h-4 mr-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <span className="sr-only">Info</span>
            <div className="text-md">
              {isAdminOrMaitreAdmin() ? (
                
                  <button  type="button"
                      onClick={() => setModalAddSiteOpen(true)}
                      className="rounded-lg font-semibold px-2 underline"
                    >
                     Créer site
                  </button>
                
              ) : (
                <strong>
                  Si vous trouvez pas votre site. Contacter le maitre
                  administrateur
                </strong>
              )}
            </div>
          </div>

          <div className="p-6 space-y-6">
            <form
              onSubmit={handleSubmit(onSubmit)}
              encType="multipart/form-data"
            >
              <div className="col-span-6 sm:col-span-6">
                <label className="block text-md font-bold leading-6 text-gray-900">
                  Site : *
                </label>

                <select
                  name="site_id"
                  id="site_id"
                  className=" my-3 border border-gray-300 text-gray-900 font-bold text-md rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
                  {...register("site_id", {
                    required: true,
                  })}
                  onChange={(e) => {
                    selectSite(e.target.value);
                  }}
                >
                  <option value={""}>Aucune</option>
                  {sites &&
                    sites?.map((site) => (
                      <option key={site.id} value={site.id}>
                        {site.nom_site}
                      </option>
                    ))}
                </select>
                {errors.site_id && (
                  <span className="bg-red-100 text-red-800 text-sm font-medium mr-2 my-4  px-2 py-1 rounded ">
                    champs obligatoire
                  </span>
                )}
              </div>

              <h3 className="text-gray-900 font-bold mb-4">
                Arborescence bâtimentaire
              </h3>

              <div className="border rounded-lg flex items-center justify-center">
                <div className="relative w-full max-h-96 overflow-auto space-y-4 mx-10 my-2">
                  {selectedSite && (
                    <ArborescenceBâtimentaire
                      site={selectedSite}
                      checkbox={true}
                      setSelectedBâtiments={setSelectedBâtiments}
                      setSelectedNiveaux={setSelectedNiveaux}
                      setSelectedEspaces={setSelectedEspaces}
                      setSelectedPieces={setSelectedPieces}
                    />
                  )}
                </div>
              </div>
              <p className=" text-lg font-thin my-4">* obligatoire</p>

              <div className="flex justify-end space-x-2 mt-5">
                <button
                  type="submit"
                  className="text-white bg-gexpertise-200 hover:bg-gexpertise-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
                >
                  Confirmer
                </button>
                <button
                  type="button"
                  onClick={() => {
                    closeModalCorrespondance();
                    setSelectedBâtiments([]);
                    setSelectedNiveaux([]);
                    setSelectedEspaces([]);
                    setSelectedPieces([]);
                    reset();
                    openModalActif();
                    setSelectedSite(null);
                  }}
                  className="text-gray-600 border border-gray-600 bg-white hover:bg-gray-100 font-medium rounded-lg text-sm px-6 py-3  text-center "
                >
                  Précèdent
                </button>
              </div>
            </form>
          </div>
        </div>
        <ModalAddSite
          modalIsOpenSite={modalAddSiteOpen}
          closeModalSite={() => {
            setModalAddSiteOpen(false);
            // Rafraîchir la liste des sites après création
            queryClient.refetchQueries({ queryKey: ["sites", client] });
          }}
          parcelles={parcelles ?? []}
        />
      </CustomDialog>
    </>
  );
};

export default ModalCorrespondanceActif;
